import React from 'react'
import PropTypes from 'prop-types'
import moment from 'moment'
import ResortFeeDialog from '../hotel/ResortFeeDialog'
import {
  isTourOperator,
  isPrePayUser,
  isNotPriceApplicableUser
} from '../helpers/userHelper'
import { getRoomName } from '../helpers/hotelHelper'

const H3IconLeft = ({icon, content}) => (
  <h3 className="icon-left">
    <i className={icon} />
    <span>{content}</span>
  </h3>
)

H3IconLeft.propTypes = {
  icon: PropTypes.string.isRequired,
  content: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.node,
    PropTypes.object
  ])
}

const BookingConfirmation = ({booking, departure, arrival, nights, user, adults}) => {

  const _outputTotal = () => {
    return (
      <div className="total-wrapper">
        <p className="thin-p space-between single-line room-total">
          <span>Total for {parseInt(nights)} {parseInt(nights) == 1 ? 'night' : 'nights'}</span>
          <em>${calcRoomTotal()}</em>
        </p>
      </div>
    )
  }

  const calcRoomTotal = () => {
    let total = 0
    if(isTourOperator(user) && !isPrePayUser(user) && booking.room.rates[0].surcharge) {
      total = Math.ceil(parseFloat(booking.room.rates[0].base)) + parseFloat(booking.room.rates[0].surcharge)
    } else {
      total = Math.ceil(booking.room.rates[0].net)
    }
    return total
  }

  const _checkAndDisplayResortFee = () => {
    // Las Vegas, display resort fee disclosure
    if(booking.hotel.destination_code === "LVS") {
      return <ResortFeeDialog />
    }
  }

  const _displayRoom = () => {
    return (
      <div className="booking-content">
        <div className="room-details">
          <H3IconLeft
            icon    = "fas fa-bed"
            content = {getRoomName(booking.room.name)}
            />
          {
            isTourOperator(user) && !isPrePayUser(user) && booking.room.rates[0].surcharge &&
            <p className="room single">
              <span className="name">Upgrade</span>
              <span className="price">${booking.room.rates[0].surcharge}</span>
            </p>
          }
        </div>
      </div>
    )
  }

  const _outputDates = () => {
    let sameYear = moment(arrival).isSame(departure, 'year')
    if(sameYear) {
      return `${moment(arrival).format("MMM Do") } to ${moment(departure).format("MMM Do, YYYY")}`
    } else {
      return `${moment(arrival).format("MMM Do, YYYY") } to ${moment(departure).format("MMM Do, YYYY")}`
    }
  }

  return (
    <div className="booking-confirmation">
      <h1>
        <i className="fas fa-check-circle success" />
        <span>Reservation Processing</span>
      </h1>
      <p className="send-note">We&apos;ll send you a confirmation email shortly.</p>

      <div className="booking-details">
        <H3IconLeft
          icon    = "fas fa-hotel"
          content = {booking.hotel.name}
          />
        <H3IconLeft
          icon    = "fas fa-calendar-alt"
          content = {_outputDates()}
          />
        { _displayRoom() }
        {
          adults > 1 &&
          <H3IconLeft
            icon    = "fas fa-user-alt"
            content = {`${adults} Adults`}
            />
        }
        { !isNotPriceApplicableUser(user) && _outputTotal() }
        { !isNotPriceApplicableUser(user) && _checkAndDisplayResortFee() }
      </div>

      <p className="actions">
        <a href="/bookings" className="button primary basic">View or Manage this Reservation</a>
        <a href="/support" className="button">Need Help with this Reservation?</a>
      </p>
    </div>
  )
}

BookingConfirmation.propTypes = {
  booking: PropTypes.object.isRequired,
  departure: PropTypes.string.isRequired,
  arrival: PropTypes.string.isRequired,
  nights: PropTypes.number.isRequired,
  adults: PropTypes.number,
  user: PropTypes.object
}

export default BookingConfirmation
